var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"guest-upgrade-step-2"}},[(_vm.hardwareOptions.length)?_c('FormButtonsSelect',{attrs:{"options":_vm.hardwareOptions,"bind-id":"hardwareOptions","aria-label":"hardware options"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }